import type { EventData } from '@/services/iframeMessenger';
import type { CheckoutData } from '@/types/checkout';
import type { ICheckoutContext } from '@/types/context';
import { getSessionIdFromUrlParams } from './location';

type EventDataSource = Partial<CheckoutData> &
  Partial<
    Pick<
      ICheckoutContext,
      'purchasedItems' | 'paymentMethodSelected' | 'promoCode' | 'card' | 'customer' | 'pricing' | 'offer' | 'orderId'
    >
  >;

/**
 * Builds the shared iframe event payload from either checkoutData or checkout context.
 */
export const getEventDataForSdkEvents = (
  eventData: EventDataSource,
  additionalProperties?: Partial<EventData>
): EventData => {
  return {
    date: Date.now().toString(),
    sessionId: getSessionIdFromUrlParams(),
    bundleName: eventData?.offer?.name,
    bundleId: eventData?.offer?.sku,
    bundleSKU: eventData?.offer?.sku,
    products: (eventData?.items ?? eventData?.purchasedItems ?? [])?.map((item) => ({
      name: item.name,
      sku: item.sku,
      quantity: item.quantity,
    })) as unknown as EventData['products'],
    totalSum: eventData?.pricing?.priceBreakdown?.priceTotal,
    totalSumCurrency: eventData?.pricing?.currencyCode,
    userId: eventData?.customer?.id,
    userCountry: eventData?.customer?.geoLocator?.countryCode2,
    orderId: eventData?.orderId || '',
    paymentMethodName: eventData?.paymentMethodSelected,
    promoCode: eventData?.promoCode ?? null,
    ...additionalProperties,
  };
};
